module.exports = __webpack_public_path__ + "sn.svg?ef9279ad268d9c8a1345d5d3ab078b59";